// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__16a9W","Label":"BuildControl_Label__1AULc","Less":"BuildControl_Less__3co7h","More":"BuildControl_More__1aDE6"};